import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "children", "className", "disabled", "icon", "onClick", "tooltip", "tooltipPlacement"];
import { PureComponent } from 'react';
import classNames from 'classnames';
import UITextToolbarButton from 'rich-text-lib/components/editor/UITextToolbarButton';
import UITextToolbarIcon from 'rich-text-lib/components/editor/UITextToolbarIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class SmallToggleButton extends PureComponent {
  render() {
    const _this$props = this.props,
      {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'active' does not exist on type 'Readonly... Remove this comment to see the full error message
        active,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
        children,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
        className,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
        disabled = false,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'icon' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        icon,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onClick' does not exist on type 'Readonl... Remove this comment to see the full error message
        onClick,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'tooltip' does not exist on type 'Readonl... Remove this comment to see the full error message
        tooltip,
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'tooltipPlacement' does not exist on type... Remove this comment to see the full error message
        tooltipPlacement = 'top'
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const finalClassName = classNames(className, 'draft-toolbar-button');
    const shouldForceTooltipClosed = disabled || active;
    return /*#__PURE__*/_jsx(UITooltip, {
      open: shouldForceTooltipClosed ? false : undefined,
      title: tooltip,
      placement: tooltipPlacement,
      children: /*#__PURE__*/_jsxs(UITextToolbarButton, Object.assign({
        className: finalClassName,
        disabled: disabled,
        onSelectedChange: onClick,
        selected: active
      }, rest, {
        children: [children, /*#__PURE__*/_jsx(UITextToolbarIcon, {
          disabled: disabled,
          name: icon
        })]
      }))
    });
  }
}